import { Action } from '@ngrx/store';
import { LocationActionTypes, LocationActions } from '../actions';
import { LocationFilterModel, LocationListModel } from '@kanzi-apes/kanzi-models';

export interface State {
  list: LocationListModel | null;
  filter: LocationFilterModel | null;
  loaded: boolean;
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  list: null,
  loaded: false,
  loading: false,
  filter: { page: 1 },
  error: null,
};

export function reducer(state: State = initialState, action: Action): State {
  const locationActions = action as LocationActions;
  switch (locationActions.type) {
    case LocationActionTypes.LoadList: {
      return {
        ...state,
        loading: true,
        filter: locationActions.payload,
      };
    }
    case LocationActionTypes.LoadListComplete: {
      return {
        ...state,
        loaded: true,
        loading: false,
        list: locationActions.payload,
      };
    }
    case LocationActionTypes.LoadListError: {
      return {
        ...state,
        loading: false,
        error: locationActions.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getList = (state: State) => state.list;
export const getFilter = (state: State) => state.filter;
export const getLoading = (state: State) => state.loading;
export const getLoaded = (state: State) => state.loaded;
